import axios from "axios"; // 引入axios
import store from "../store/store";
import router from "../router/index";
import { Message, Loading } from "element-ui";

// 环境切换
let baseUrl = "";
if (process.env.NODE_ENV == "development") {
  baseUrl = "/aiApi";
} else if (process.env.NODE_ENV == "debug") {
  baseUrl = "/aiApi";
} else if (process.env.NODE_ENV == "production") {
  baseUrl = "/aiApi";
}

const aiAxios = axios.create({
  timeout: 10000,
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

// 请求拦截器
aiAxios.interceptors.request.use(
  (config) => {
    var token = localStorage.getItem("Authorization");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    Message.error({ message: "请求错误!" });
    return error;
  }
);

// 响应拦截器
aiAxios.interceptors.response.use(
  (response) => {
    console.log("response", response);
    const resData = response.data;
    if (resData.code === 500) {
      Message.error({ message: resData.msg || "服务异常，请稍后再试。" });
      return Promise.reject(response);
    }
    // 静默探测请求（登录桥接验证 token 用）：失败不弹窗不清理，只向上抛错
    if ((resData.code === 401 || resData.code === 403)
        && response.config && response.config.headers && response.config.headers['X-Silent-Auth']) {
      return Promise.reject(response);
    }
    if (resData.code === 401 || resData.code === 403) {
      Message.error({
        message:
          resData.code === 401
            ? "您暂未登录，请登录后使用！"
            : "授权过期，请重新登录。",
      });
      localStorage.removeItem("token");
      store.commit("loginSuccess", null);
      store.commit("setDialogVisibleLogin", true);
      store.commit('aiUserLogout', true);
      return Promise.reject(response);
    }
    return Promise.resolve(resData);
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error && error.code === "ECONNABORTED") {
      Message.error({ message: "请求超时，若为长文本合成请稍后到合成记录中查看结果" });
    }
    // 超时等场景 error.response 为 undefined，兜底成可被 e.data 访问的形状
    return Promise.reject(error.response || { data: null });
  }
);

export default aiAxios;
